import { loadFromLocal, saveToLocal } from './utils'
import { normalizeHoleId } from './courseProgress'

export const MAX_PENDING_SCORE_ATTEMPTS = 5

/** v2: pre-fix builds queued under `pendingScores` and replayed after DB wipes; this key starts fresh. */
export const PENDING_SCORES_STORAGE_KEY = 'puttzin_pending_scores_v2'

const STORAGE_KEY = PENDING_SCORES_STORAGE_KEY

function preserveIdType(id) {
  if (typeof id === 'string' && id.includes('-')) return id
  if (typeof id === 'number') return id
  if (typeof id === 'string') {
    const num = parseInt(id, 10)
    return Number.isNaN(num) || num.toString() !== id ? id : num
  }
  return String(id)
}

export function buildPendingScorePayload(entry) {
  return Object.entries(entry?.scores || {}).map(([playerId, score]) => ({
    player_id: String(preserveIdType(playerId)),
    score: parseInt(score, 10),
    mulligan_applied: Boolean((entry?.mulligansApplied || {})[playerId]),
  }))
}

export function recordPendingScoreFailure(entry, maxAttempts = MAX_PENDING_SCORE_ATTEMPTS) {
  const attempts = (entry?._attempts || 0) + 1
  if (attempts >= maxAttempts) return null
  return { ...entry, _attempts: attempts }
}

/** After a successful server save, drop queued rows so a DB wipe is not replayed by usePendingScoresSync. */
export function removePendingScoresForTeamHole(teamId, holeId) {
  const hid = normalizeHoleId(holeId)
  if (hid == null || teamId == null) return
  const tid = String(teamId)
  const queue = loadFromLocal(STORAGE_KEY)
  if (!Array.isArray(queue) || queue.length === 0) return
  const pruned = queue.filter((entry) => {
    if (!entry) return false
    if (String(entry.team_id) !== tid) return true
    return normalizeHoleId(entry.hole_id) !== hid
  })
  if (pruned.length === queue.length) return
  saveToLocal(STORAGE_KEY, pruned.length ? pruned : null)
}
